import axios from "axios";
import Base from "./base";

class Educations extends Base {}

const state = {
  educations: new Educations(),
};

const getters = {
  educations: (state) => state.educations,
};

const actions = {
  async fetchEducations({ commit }) {
    commit("setLoadingEducations", true);
    const res = await axios.get(
      "https://agungsepruloh.herokuapp.com/educations"
    );
    commit("setLoadingEducations", false);
    commit("setEducations", res.data);
  },
};

const mutations = {
  setEducations: (state, educations) => (state.educations = educations),
  setLoadingEducations: (state, value) => (state.educations.isLoading = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
